import parsePhoneNumberFromString from "libphonenumber-js";
import { useState, useEffect } from "react";

export const getServicesArray = (services) => {    
    if (typeof services === 'string') {
        try {
            const parsedArray = JSON.parse(services);
            if (Array.isArray(parsedArray)) {
                return parsedArray;
            }else{
                return JSON.parse(parsedArray);
            }
        } catch (e) {
            console.error('Invalid JSON string:', e);
        }
    }
    return Array.isArray(services) ? services : [];
}

export const isValidPhoneNumber = (inputNumber, country) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(inputNumber, country?.iso2?.toUpperCase());
        return phoneNumber?.isValid() || false;
    } catch (err) {
        console.log(err)
    }
};

export const validateDescription = (value) => {
    const maxLength = 255;
    const regex = /^[a-zA-Z0-9 ,.?/()@$'\n]*$/;

    if (value.length > maxLength) {
        return {
            valid: false,
            error: `Description cannot exceed ${maxLength} characters.`
        };
    } else if (!regex.test(value)) {
        return {
            valid: false,
            error: 'Description contains invalid characters.'
        };
    } else {
        return {
            valid: true,
            error: ''
        };
    }

}

export const pluralize = (word) => {
    if (!!word) {
        if (word.endsWith('y') && !word.endsWith('ay') && !word.endsWith('ey') && !word.endsWith('oy') && !word.endsWith('uy')) {
            return word.slice(0, -1) + 'ies';
        } else if (word.endsWith('s') || word.endsWith('x') || word.endsWith('z') || word.endsWith('ch') || word.endsWith('sh')) {
            return word + 'es';
        } else {
            return word + 's';
        }
    }
}

export const trimFromString = (str)=>{
    if(!!str){
        let newStrAry = str.trim().split(' ');
        let joinStrAry = newStrAry.join(' ');        
        return joinStrAry;
    }
}


export const filterBySlug = (businessCatData, slug) => {        
    if(!!businessCatData && businessCatData.length>0){
        let bbData = businessCatData.filter(category => category.cat_slug == slug);
        return bbData?bbData[0]?.cat_name:slug;
    }else{
        return slug;
    }
};

export const getcoutryfromlocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords;
  
            const response = await fetch(
              `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
            );
            const data = await response.json();
  
            if (data?.countryCode) {
              resolve(data.countryCode);
            } else {
              resolve(null);
            }
          } catch (error) {
            console.error("Error fetching location data:", error);
            reject(error);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          reject(error);
        }
      );
    });
};

let cachedCountryCode = null;
let subscribers = [];

 export const useLocation = () => {
  const backendApiUrl = process.env.REACT_APP_BACKEND_URL;
  const [countryCode, setCountryCode] = useState(cachedCountryCode || "");

  const notifySubscribers = (code) => {
    subscribers.forEach((fn) => fn(code));
    subscribers = [];
  };

  useEffect(() => {
    if (cachedCountryCode) {
      setCountryCode(cachedCountryCode);
      return;
    }

    if (subscribers.length > 0) {
      subscribers.push(setCountryCode);
      return;
    }

    subscribers.push(setCountryCode);

    const getCountryFromLocation = () =>
      new Promise((resolve, reject) => {
        if (!navigator.geolocation) return reject("Geolocation not supported");

        navigator.geolocation.getCurrentPosition(
          ({ coords }) => {
            fetch(
              `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${coords.latitude}&longitude=${coords.longitude}&localityLanguage=en`
            )
              .then((res) => res.json())
              .then((data) => resolve(data?.countryCode?.toLowerCase()))
              .catch(reject);
          },
          reject
        );
      });

    const getCountryFromIP = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        return data?.country_code?.toLowerCase() || null;
      } catch {
        return null;
      }
    };

    const getCountryFromBackend = async () => {
      if (!backendApiUrl) return "in";
      try {
        const res = await fetch(`${backendApiUrl}api/v1/business/getCountryCodePhoneCode`);
        const { result } = await res.json();
        return result?.countryCode?.toLowerCase() || "in";
      } catch {
        return "in";
      }
    };

    const detectCountry = async () => {
      let detected = null;
      try {
        detected = await getCountryFromLocation();
      } catch {}

      if (!detected) {
        try {
          detected = await getCountryFromIP();
        } catch {}
      }

      if (!detected) {
        detected = await getCountryFromBackend();
      }

      cachedCountryCode = detected || "in";
      notifySubscribers(cachedCountryCode);
    };

    detectCountry();
  }, [backendApiUrl]);

  return { countryCode };
};
